<template>
  <div class="msg-container">
    <step :active="0"></step>
    <div class="formDiv">
      <van-form @failed="onFailed" @submit="onSubmit">
        <van-cell-group inset>
          <!-- 循环显示 -->
          <div v-for="item in formItems" :key="item.key">
            <van-field
              v-if="
                item.key !== 'Gender' &&
                item.key !== 'Country' &&
                item.key !== 'Province' &&
                item.key !== 'City' &&
                item.key !== 'Trade' &&
                item.key !== 'photo' &&
                item.key !== 'IDCardType' &&
                item.key !== 'ExtField1'&&
                item.key !== 'ComName'
              "
              v-model="formMg[item.key]"
              :name="item.key"
              :label="item.Name"
              :rules="rulesAll[item.key]"
              :class="item.IsMust ? 'requiredItem' : ''"
              :readonly="
                (item.key === 'Mobile' && tabac === 'dl') ||
                (item.key === 'Email' && tabac === 'gat')
              "
            />
            <div v-else-if="item.key === 'ComName'" style="position: relative;">
            <van-field
              v-model="formMg[item.key]"
              :name="item.key"
              :label="item.Name"
              :rules="rulesAll[item.key]"
              :class="item.IsMust ? 'requiredItem' : ''"
            />

            <div v-if="companySuggestions && companySuggestions.length > 0&&item.key=='ComName'" class="suggestion-list">
          <div
            v-for="(suggestion, index) in companySuggestions"
            :key="index"
            class="suggestion-item"
            @click="selectSuggestion(suggestion)"
          >
            {{ suggestion }}
          </div>
        </div>
            </div>
            <!-- 头像 -->
            <van-field
              v-if="item.key === 'photo'"
              :name="formMg[item.key]"
              label="头像"
              :rules="rulesAll.photo"
              :class="item.IsMust ? 'photoForm requiredItem' : 'photoForm'"
              v-model="formMg[item.key]"
            >
              <template #input>
                <cropper @send-photo="sendphoto" />
              </template>
            </van-field>
            <!-- gender -->
            <van-field
              v-if="item.key === 'Gender'"
              :class="item.IsMust ? 'requiredItem' : ''"
              :name="item.key"
              :label="item.Name"
              :rules="rulesAll.Gender"
            >
              <template #input>
                <van-radio-group v-model="formMg.Gender" direction="horizontal">
                  <van-radio name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <!-- 国家选择pc -->
            <template v-if="item.key === 'Country'">
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  :readonly="true"
                  v-model="formMg.Country"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.Country"
                >
                </van-field>
                <select v-model="formMg.Country" @change="changeCountry">
                  <option
                    v-for="(item, index) in columns"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 国家 移动 -->
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-if="!isPC"
                v-model="formMg.Country"
                is-link
                readonly
                name="Country"
                :label="item.Name"
                @click="showPicker = true"
                :rules="rulesAll.Country"
              >
              </van-field>
              <van-popup v-model:show="showPicker" position="bottom">
                <van-picker
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
            </template>
            <!-- 省份 -->
            <template v-if="item.key === 'Province' && showProvinceCity">
              <!-- pc -->
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  :readonly="true"
                  v-model="formMg.Province"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.Province"
                  :disabled="formMg.Country !== '中国'"
                >
                </van-field>
                <select
                  v-model="formMg.Province"
                  @change="changeProvince"
                  :disabled="formMg.Country !== '中国'"
                >
                  <option
                    v-for="(item, index) in columnsProvince"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 移动 -->
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-if="!isPC"
                v-model="formMg.Province"
                is-link
                readonly
                :name="item.key"
                :label="item.Name"
                @click="columnsProvince.length > 0 ? (showPickerPro = true) : ''"
                :rules="rulesAll.Province"
                :disabled="formMg.Country !== '中国'"
              />
              <van-popup v-model:show="showPickerPro" position="bottom">
                <van-picker
                  :columns="columnsProvince"
                  @confirm="onConfirmProvince"
                  @cancel="showPickerPro = false"
                />
              </van-popup>
            </template>
            <!-- 城市 -->
            <template v-if="item.key === 'City' && showProvinceCity">
              <!-- pc -->
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  :readonly="true"
                  v-model="formMg.City"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.City"
                  :disabled="formMg.Country !== '中国'"
                >
                </van-field>
                <select
                  v-model="formMg.City"
                  :disabled="formMg.Country !== '中国'"
                >
                  <option
                    v-for="(item, index) in columnsCity"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 移动 -->
              <van-field
                v-else
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.City"
                is-link
                readonly
                :name="item.key"
                :label="item.Name"
                @click="columnsCity.length > 0 ? (showShopPicker = true) : ''"
                :rules="rulesAll.City"
                :disabled="formMg.Country !== '中国'"
              />
              <van-popup v-model:show="showShopPicker" position="bottom">
                <van-picker
                  :columns="columnsCity"
                  @confirm="shopConfirm"
                  @cancel="showShopPicker = false"
                />
              </van-popup>
            </template>
            <!-- 行业 -->
            <template v-if="item.key === 'Trade'">
              <!-- pc -->
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  v-model="formMg.Trade"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.Trade"
                >
                </van-field>
                <select v-model="formMg.Trade">
                  <option
                    v-for="(item, index) in item.Options"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 移动 -->
              <van-field
                v-else
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.Trade"
                :name="item.key"
                :label="item.Name"
                @click="showTradePicker = true"
                :rules="rulesAll.Trade"
                readonly
              />
              <van-popup v-model:show="showTradePicker" position="bottom">
                <van-picker
                  :columns="tradeOptions"
                  @confirm="tradeConfirm"
                  @cancel="showTradePicker = false"
                />
              </van-popup>
            </template>
            <!-- ExtField1 -->
            <template v-if="item.key === 'ExtField1'">
              <!-- pc -->
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  v-model="formMg.ExtField1"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.ExtField1"
                >
                </van-field>
                <select v-model="formMg.ExtField1">
                  <option
                    v-for="(item, index) in ExtField1Ops"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 移动 -->
              <van-field
                v-else
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField1"
                :name="item.key"
                :label="item.Name"
                @click="showF1Picker = true"
                :rules="rulesAll.ExtField1"
                readonly
              />
              <van-popup v-model:show="showF1Picker" position="bottom">
                <van-picker
                  :columns="ExtField1Ops"
                  @confirm="f1Confirm"
                  @cancel="showF1Picker = false"
                />
              </van-popup>
            </template>
            <!-- ExtField2 -->
            <!-- <template v-if="item.key === 'ExtField2'">
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  v-model="formMg.ExtField2"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.ExtField2"
                >
                </van-field>
                <select v-model="formMg.ExtField2">
                  <option
                    v-for="(item, index) in ExtField2Ops"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <van-field
                v-else
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField2"
                :name="item.key"
                :label="item.Name"
                @click="showF2Picker = true"
                :rules="rulesAll.ExtField2"
                readonly
              />
              <van-popup v-model:show="showF2Picker" position="bottom">
                <van-picker
                  :columns="ExtField2Ops"
                  @confirm="f2Confirm"
                  @cancel="showF2Picker = false"
                />
              </van-popup>
            </template> -->
            <!-- 身份证件类型 -->
            <template v-if="item.key === 'IDCardType'">
              <!-- pc -->
              <div class="fakeSel" v-if="isPC">
                <van-field
                  :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                  v-model="formMg.IDCardType"
                  :name="item.key"
                  :label="item.Name"
                  :rules="rulesAll.IDCardType"
                  :placeholder="item.holder"
                >
                </van-field>
                <select v-model="formMg.IDCardType">
                  <option
                    v-for="(item, index) in IDTypes"
                    :key="index"
                    :value="item.text"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <!-- 移动 -->
              <van-field
                v-else
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.IDCardType"
                is-link
                readonly
                :name="item.key"
                :label="item.Name"
                @click="showIDTypePicker = true"
                :rules="rulesAll.IDCardType"
                :placeholder="item.holder"
              />
              <van-popup v-model:show="showIDTypePicker" position="bottom">
                <van-picker
                  :columns="IDTypes"
                  @confirm="IDTypeConfirm"
                  @cancel="showIDTypePicker = false"
                />
              </van-popup>
            </template>
          </div>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            style="width: 100%; border-radius: 44px"
            :color="mainColor"
            type="primary"
            native-type="submit"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cropper from '@/components/cropper.vue'
import {
  validatorName,
  validatorComName,
  validatorGender,
  validatorRank,
  validateDept,
  validatorMobile,
  validatorEmail,
  validatorAddress,
  validatorUrl,
  validatorFax,
  validateZipCode
} from '@/utils/validators.js'
import { regCId, regIDNumber } from '@/utils/regs.js'
import api from '@/api'
// import cpc from '@/utils/cpc.js'
import { constants } from 'fs'
import step from '@/components/step.vue'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
const store = useStore()
const token = computed(() => store.state.token)
const ExhCode = computed(() => store.state.ExhCode)
const loginForm = computed(() => store.state.loginForm)
const isPC = computed(() => store.state.isPC)
const mainColor = computed(() => store.state.mainColor)
const openid = computed(() => store.state.openid)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const mobile = computed(() => store.state.mobile)

const isSelectingSuggestion = ref(false)

const companySuggestions = ref([]) // 用于存储接口返回的建议内容
const companyInputTimer = ref(null)
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const isWeX = computed(() => store.state.isWeX)
const tabac = ref(sessionStorage.getItem('tabac'))
const showProvinceCity = ref(true) // 控制省份城市显示隐藏
const router = useRouter()
const route = useRoute()
const actid = route.query.id

const getMobileValue = () => {
  // 优先从 sessionStorage 获取
  const sessionMobile = sessionStorage.getItem('mobile')
  if (sessionMobile) {
    return sessionMobile
  }
  // 其次从 store 获取
  if (store.state.mobile) {
    return store.state.mobile
  }
  // 最后从登录表单获取
  if (tabac.value === 'dl' && loginForm.value?.mobile) {
    return loginForm.value.mobile
  }
  return ''
}
const formMg = ref({
  Name: '',
  ComName: '',
  Gender: '', // n
  Rank: '',
  Dept: '', // n
  Mobile: getMobileValue(), // loginForm.value.mobile || '',
  Country: tabac.value === 'gat' ? '' : '中国',
  Province: '',
  City: '',
  Email: loginForm.value.Email || '',
  Address: '',
  WebUrl: '', // n
  Fax: '', // n
  Tel: '',
  IDCardNo: '',
  Trade: '', // n
  ZipCode: '', // n
  Remark: '', // n
  photo: '',
  IDCardType: '',
  OpenID: '',
  AliID: ''
})
onMounted(() => {
  // 确保主题色同步到 CSS 变量
  if (mainColor.value) {
    document.documentElement.style.setProperty('--color-primary', mainColor.value)
  }
  console.log('mainColor:', mainColor.value)
  getForm()
  if (actid) {
    getMeetDetail()
  }
  if (isWeX.value) {
    wx.getWXSign()
  }
  // 修复 iOS Safari ：点击键盘“完成”后页面被重置到顶部的问题
  setupIOSScrollFix()
})

onBeforeUnmount(() => {
  teardownIOSScrollFix()
})

// =============================
// iOS 输入框完成后页面跳顶修复
// =============================
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
// 记录最后一个失焦的输入元素，用于在 iOS 键盘收起后把它滚回视野
let lastBlurEl = null
let restoreTimers = []
const clearRestoreTimers = () => {
  restoreTimers.forEach((t) => clearTimeout(t))
  restoreTimers = []
}
const isFormField = (el) => {
  if (!el || !el.tagName) return false
  const tag = el.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT'
}
const onIOSFocusIn = (e) => {
  if (isFormField(e.target)) {
    // 新的输入框获得焦点，取消上一轮未执行的恢复
    clearRestoreTimers()
    lastBlurEl = null
  }
}
const restoreToBlurEl = () => {
  const el = lastBlurEl
  if (!el || !el.isConnected) return
  // 如果现在又有另一个输入框被聚焦了（跳转下一项），交给 focusin 处理，这里不动
  if (isFormField(document.activeElement) && document.activeElement !== el) return
  try {
    el.scrollIntoView({ block: 'center', behavior: 'auto' })
  } catch (_) {
    // 老版本在不支持 options 时退回默认参数
    el.scrollIntoView()
  }
}
const onIOSFocusOut = (e) => {
  if (!isFormField(e.target)) return
  lastBlurEl = e.target
  clearRestoreTimers()
  // iOS 键盘收起后 Safari 会多次跳动滚动位置，在多个时间点都把刚失焦的输入框拽回视野
  ;[60, 200, 400, 700].forEach((delay) => {
    restoreTimers.push(setTimeout(restoreToBlurEl, delay))
  })
}
const setupIOSScrollFix = () => {
  if (!isIOS) return
  document.addEventListener('focusin', onIOSFocusIn, true)
  document.addEventListener('focusout', onIOSFocusOut, true)
}
const teardownIOSScrollFix = () => {
  if (!isIOS) return
  document.removeEventListener('focusin', onIOSFocusIn, true)
  document.removeEventListener('focusout', onIOSFocusOut, true)
  clearRestoreTimers()
}
watch(() => formMg.value.ComName, // 修正属性名
  (newVal) => {
    return
    // console.log('companyname:', newVal)
    if (isSelectingSuggestion.value) {
      isSelectingSuggestion.value = false // 重置标志位
      return
    }
    // 注意：您需要定义 onCompanyInput 函数
    onCompanyInput(newVal)
  },
  { immediate: false }
)
const onCompanyInput = () => {
  const value = formMg.value.ComName
  // 清除之前的定时器
  if (companyInputTimer.value) {
    clearTimeout(companyInputTimer.value)
  }

  // 设置新的定时器，实现防抖
  companyInputTimer.value = setTimeout(() => {
    // console.log("132",value);
    if (value && value.length >= 2) { // 当输入至少2个字符时才调用接口
    // console.log(value.length);
      fetchCompanySuggestion(value)
    } else {
      companySuggestions.value = []; // 输入字符过少时清空建议
    }
  }, 500) // 500ms防抖延迟
}
// 调用接口获取单位名称相关建议
const fetchCompanySuggestion = (companyName) => {
  //  console.log('companyName111:', companyName);
  // 这里替换为你的实际API调用
  // 示例：
  // companySuggestions.value = ['杭州奥极科技有限公司','广州市奥极艺国际进出口有限公司','深圳市奥极健康有限公司','北京奥极科技有限公司','上海奥极科技服务有限公司'];
  // return;
  api.getCompanySuggestion({ ExhCode: ExhCode.value, companyname: companyName }).then(res => {
    if (res.code === 200 && res.data) {
      companySuggestions.value = res.data.checkResult
    } else {
      companySuggestions.value = []
    }
  }).catch(() => {
    companySuggestions.value = []
  })

  // console.log('companySuggestions:', companySuggestions);
  // 模拟接口调用（请替换为实际接口）
  // this.companySuggestions = ['杭州奥极科技有限公司','广州市奥极艺国际进出口有限公司','深圳市奥极健康有限公司','北京奥极科技有限公司','上海奥极科技服务有限公司'];
}
const selectSuggestion = (suggestion) => {
  isSelectingSuggestion.value = true
  formMg.value.ComName = suggestion
  companySuggestions.value = [] // 选择后清空建议列表
}
// 校验省份
const validatorProvince = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      // console.log('shengsheng')
      return false
    }
    return true
  }
  return true
}
// 校验城市
const validatorCity = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      return false
    }
    return true
  }
  return true
}
// 校验证件号
const validatorIDCardNo = (val, { required }) => {
  if (required) {
    if (val) {
      if (
        formMg.value.IDCardType &&
        formMg.value.IDCardType === '中国大陆居民身份证'
      ) {
        return regCId(val)
      } else if (
        !formMg.value.IDCardType &&
        formMg.value.Country &&
        formMg.value.Country === '中国'
      ) {
        return regCId(val)
      } else if (
        formMg.value.IDCardType === '' &&
        formMg.value.Country === ''
      ) {
        return regCId(val)
      } else {
        return regIDNumber.test(val)
      }
      // if (
      //   formMg.value.IDCardType === '中国大陆居民身份证' ||
      //   formMg.value.Country === '中国' ||
      //   (formMg.value.IDCardType === '' && formMg.value.Country === '')
      // ) {
      //   return regCId(val)
      // } else {
      //   return regIDNumber.test(val)
      // }
    }
    return false
  } else {
    if (val) {
      if (
        formMg.value.IDCardType === '中国大陆居民身份证' ||
        formMg.value.Country === '中国' ||
        (formMg.value.IDCardType === '' && formMg.value.Country === '')
      ) {
        return regCId(val)
      } else {
        return regIDNumber.test(val)
      }
    }
  }
  return true
}

const vlidateMobileHn = (val, { required }) => {
  if (formMg.value.Country === '中国') {
    return validatorMobile(val, { required })
  } else {
    return true
  }
}
const rulesAll = ref({})
const rulesModel = {
  Name: [
    { required: false, validator: validatorName, message: '请输入正确的' }
  ],
  ComName: [
    { required: false, validator: validatorComName, message: '请输入正确的' }
  ],
  ComEName: [{ required: false, message: '请输入' }],
  Gender: [{ required: false, validator: validatorGender, message: '请选择' }],
  Rank: [
    { required: false, validator: validatorRank, message: '请输入正确的' }
  ],
  Dept: [{ required: false, validator: validateDept, message: '请输入' }],
  Mobile: [
    {
      required: false,
      validator: vlidateMobileHn,
      message: '请输入正确的'
    }
  ],
  Country: [{ required: false, message: '请选择' }],
  Province: [
    { required: false, validator: validatorProvince, message: '请选择' }
  ],
  City: [{ required: false, validator: validatorCity, message: '请选择' }],
  Email: [
    { required: false, validator: validatorEmail, message: '请输入正确的' }
  ],
  Address: [
    {
      required: false,
      validator: validatorAddress,
      message: '请输入正确的'
    }
  ],
  WebUrl: [
    { required: false, validator: validatorUrl, message: '请输入正确的' }
  ],
  Fax: [{ required: false, validator: validatorFax, message: '请输入正确的' }],
  Tel: [{ required: false, validator: validatorFax, message: '请输入正确的' }],
  IDCardNo: [
    { required: false, validator: validatorIDCardNo, message: '请输入正确的' }
  ],
  Trade: [{ required: false, message: '请选择' }],
  ZipCode: [
    { required: false, validator: validateZipCode, message: '请输入正确的' }
  ],
  Remark: [{ required: false, message: '请输入' }],
  photo: [{ required: true, message: '请上传' }],
  IDCardType: [{ required: true, message: '请选择' }],
  ExtField1: [{ required: true, message: '请选择' }],
  ExtField2: [{ required: true, message: '请输入' }]
}
// 解析选项
const dealOp = (str) => {
  if (str) {
    return str.split(';').map((item) => {
      return { text: item, value: item }
    })
  } else {
    return []
  }
}
// 行业选项
const tradeOptions = ref([])
const ExtField1Ops = ref([])
const ProvinceOptions = ref([])
// const ExtField2Ops = ref([])
// 获取信息配置
const formItems = ref([])
const getForm = async () => {
  const res = await api.formConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const formObj = JSON.parse(decryptionECB(res.data.configuartion))
    // console.log(formObj, 'formObj')
    formItems.value = formObj
      .filter((item) => item.IsShow)
      .sort((a, b) => {
        return a.Sort - b.Sort
      })
    formItems.value.forEach((item) => {
      if (
        item.key === 'Gender' ||
        item.key === 'Country' ||
        item.key === 'Province' ||
        item.key === 'City' ||
        item.key === 'Trade' ||
        item.key === 'photo' ||
        item.key === 'IDCardType' ||
        item.key === 'ExtField1'
      ) {
        if (item.key === 'Country') {
          item.Name = tabac.value === 'gat' ? '地区' : item.Name
        }
        if (item.key === 'Province') {
          ProvinceOptions.value = dealOp(item.Options)
        }
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.Name
        if (item.key === 'Trade') {
          tradeOptions.value = dealOp(item.Options)
        }
        if (item.key === 'ExtField1') {
          ExtField1Ops.value = dealOp(item.Options)
        }
      } else {
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.Name
      }
      rulesModel[item.key][0].required = item.IsMust
      rulesAll.value[item.key] = rulesModel[item.key]
    })
    getCountry()
  }
}
// 关闭上传头像
const sendphoto = (data) => {
  formMg.value.photo = data
  Object.assign(formMg.value, { photo: data })
}
// 表单验证失败
const onFailed = (errorInfo) => {
  // console.log('failed', errorInfo)
}
// 表单验证成功提交
const onSubmit = async (values) => {
  const subObj = { ...formMg.value }
  subObj.photoUrl = subObj.photo
  // console.log(subObj)
  // return
  // 是否有调查问卷
  const hasQues = gconfig.value.IsHaveQuestion === 'True'
  // 是否需要审核
  const needCheck = gconfig.value.IsNeedCheck === 'True'
  const param = {
    ...subObj,
    ExhCode: ExhCode.value,
    token: token.value,
    ifSubmit: !hasQues,
    OpenID: openid.value,
    AliID: '',
    source: sessionStorage.getItem('source') || '',
    invitesource: sessionStorage.getItem('invitesource') || '',
    invitesourceid: sessionStorage.getItem('invitesourceID') || '',
    lan: 'cn'
  }
  const res = await api.visitorSaveApi(param)
  if (res.code === 200) {
    if (hasQues) {
      router.push({ path: '/questions' })
      return
    }
    store.commit('setVisitorID', res.data.visitorID)
    sessionStorage.setItem('invitesource', '1')
    sessionStorage.setItem('invitesourceID', res.data.visitorID)
    if (gconfig.value.SuccessPageVersion === 'V2') {
      router.push({ path: '/successV2' })
    } else {
      router.push({ path: '/success' })
    }
  }
}
// 行业下拉
const showTradePicker = ref(false)
const tradeConfirm = ({ selectedOptions }) => {
  formMg.value.Trade = selectedOptions[0].text
  showTradePicker.value = false
}
// ExtField1 下拉
const showF1Picker = ref(false)
const f1Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField1 = selectedOptions[0].text
  showF1Picker.value = false
}
// ExtField2 下拉
const showF2Picker = ref(false)
const f2Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField2 = selectedOptions[0].text
  showF2Picker.value = false
}
// 国家下拉
const showPicker = ref(false)
const columns = ref([])
// columns.value = cpc.country1.map((item) => {
//   const tmpArr = item.split('_')
//   return { text: tmpArr[1], value: tmpArr[0] }
// })
const getCountry = () => {
  api.countryApi({}).then((res) => {
    columns.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
    if (tabac.value === 'gat') {
      columns.value = columns.value.splice(1, 3)
    }
    getProsH()
  })
}

const onConfirm = ({ selectedOptions }) => {
  formMg.value.Country = selectedOptions[0].text
  showPicker.value = false
  changeCountry()
}
// 国家变化
const changeCountry = () => {
  formMg.value.Province = ''
  formMg.value.City = ''
  columnsProvince.value = []
  columnsCity.value = []
  if (formMg.value.Country === '中国') {
    showProvinceCity.value = true
    getProsH()
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.City
    const findPObj = formItems.value.find((item) => item.key === 'Province')
    if (findPObj) {
      if (findPObj.IsMust) {
        // 如果必选
        pRule[0].required = true
      } else {
        pRule[0].required = false
      }
    }
    const findCObj = formItems.value.find((item) => item.key === 'City')
    if (findCObj) {
      if (findCObj.IsMust) {
        // 如果必选
        cRule[0].required = true
      } else {
        cRule[0].required = false
      }
    }
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  } else {
    // 非中国，隐藏省份城市
    showProvinceCity.value = false
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.City
    if (pRule) pRule[0].required = false
    if (cRule) cRule[0].required = false
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  }
  if (formMg.value.Country === '中国') {
    formMg.value.IDCardType = '中国大陆居民身份证'
  } else if (
    formMg.value.Country === '中国香港' ||
    formMg.value.Country === '中国澳门'
  ) {
    formMg.value.IDCardType = '港澳通行证'
  } else if (formMg.value.Country === '中国台湾') {
    formMg.value.IDCardType = '台胞证'
  } else {
    formMg.value.IDCardType = '护照'
  }
}
// 省份下拉
// 获取省份下拉选项
const columnsProvince = ref([])
const getProsH = () => {
  // columnsProvince.value = cpc.province.map((item) => {
  //   const tmpArr = item.split('_')
  //   return { text: tmpArr[2], value: tmpArr[1] }
  // })
  api.proApi({}).then((res) => {
    const formPro = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
    // .log(ProvinceOptions.value, 'res.data')
    if (ProvinceOptions.value.length > 0) {
      sortPro(
        ProvinceOptions.value,
        formPro
      )
    }
    columnsProvince.value = [...formPro]
  })
}
// 省份排序
const sortPro = (val, arr) => {
  val.forEach((valItem) => {
    const index = arr.findIndex((item) => {
      return valItem.text === item.text
    })
    if (index > -1) {
      const findObj = arr.splice(index, 1)
      arr.unshift(findObj[0])
    }
  })
}

const showPickerPro = ref(false)
const onConfirmProvince = ({ selectedOptions }) => {
  formMg.value.Province = selectedOptions[0].text
  showPickerPro.value = false
  changeProvince()
}
// 省份变化
const changeProvince = () => {
  formMg.value.City = ''
  columnsCity.value = []
  getCity()
}
// 城市
// 城市下拉
const columnsCity = ref([])
const getCity = () => {
  columnsCity.value = []
  // cpc.city.map((item) => {
  //   const tmpArr = item.split('_')
  //   if (formMg.value.Province === tmpArr[1]) {
  //     columnsCity.value.push({ text: tmpArr[3], value: tmpArr[2] })
  //   }
  // })
  api.cityApi({ name: formMg.value.Province }).then((res) => {
    columnsCity.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
const showShopPicker = ref(false)

const shopConfirm = ({ selectedOptions }) => {
  formMg.value.City = selectedOptions[0].text
  showShopPicker.value = false
}
// 身份证件类型
const IDTypes = ref([
  { text: '中国大陆居民身份证', value: '中国大陆居民身份证' },
  { text: '港澳通行证', value: '港澳通行证' },
  { text: '台胞证', value: '台胞证' },
  { text: '护照', value: '护照' }
])
const showIDTypePicker = ref(false)
const IDTypeConfirm = ({ selectedOptions }) => {
  formMg.value.IDCardType = selectedOptions[0].text
  showIDTypePicker.value = false
}
// 获取会议详情
const getMeetDetail = async () => {
  const res = await api.getActiviInfoApi({ token: token.value, ActID: actid })
  formMg.value = { ...res.data }
  formMg.value.Name = res.data.RecipientName
}
</script>
<style lang="less">
@import '../../assets/login.less';

/* 页面容器滚动支持 */
.msg-container {
  display: flex;
  flex-direction: column;
  
  /* 对于PC端，确保内容可以滚动 */
  @media screen and (min-width: 768px) {
    overflow-y: auto;
  }
}

/* 修改建议列表样式 */
.suggestion-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  //max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
 // margin-top: 5px;
}

.suggestion-item {
  padding: 10px 15px;
  color: #333;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
}

/* 为包含建议列表的字段容器添加相对定位 */
.van-cell-group .van-cell:last-child {
  position: relative;
}

.lcbox {
  border: 1px solid #ececec;
  box-sizing: border-box;
  width: 99vw;
  border-radius: 3px;
  margin: 10px auto 0;
}

.fakeSel {
  position: relative;

  // 原生 select 透明覆盖在 van-field 上：
  // 视觉上看到的是 vant 样式化的字段，点击任意位置则弹出原生下拉
  // 注意：不能设 `color: transparent`，原生下拉面板中的 option 会继承颜色导致选项看不见
  // 右侧下拉箭头由全局 .selItem .van-field__body::after 提供，这里不重复添加
  select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    opacity: 0;
    cursor: pointer;
    z-index: 2;

    &:disabled {
      cursor: not-allowed;
    }
  }
}

.formDiv {
  padding: 0 4px;
  width: 92%;
  margin: 0 auto;
  border-radius: 6px;
  position: relative;
  flex: 1;

  // inset分组卡片样式优化
  .van-cell-group--inset {
    margin: 12px 0;
    border-radius: var(--radius-lg, 12px);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    &:first-child {
      margin-top: 0;
    }
  }

  // 标签与输入框间距优化
  .van-field__label {
    width: 100%;
    margin-bottom: 4px;
    font-weight: 500;
    color: var(--text-secondary, #666);
  }

  // 单选/多选样式优化
  .van-radio,
  .van-checkbox {
    padding: 12px 16px;
    margin: 4px 0;
    border-radius: var(--radius-md, 8px);
    background: #FAFBFC;
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.98);
    }
  }

  // 选中状态背景色淡化效果
  .van-radio[aria-checked="true"],
  .van-checkbox[aria-checked="true"] {
    background: rgba(230, 0, 68, 0.08);
    border: 1px solid rgba(230, 0, 68, 0.2);
  }

  .van-radio-group,
  .van-checkbox-group {
    padding: 8px 0;
  }

  // 性别选择横向布局优化
  .van-radio-group[direction="horizontal"] {
    display: flex;
    gap: 12px;

    .van-radio {
      flex: 1;
      justify-content: center;
    }
  }
}

// 头像
.photoForm {
  .van-field__value {
    text-align: center;
  }
  .van-field__body {
    display: inline-block;
    border: 0;
  }
}
</style>
